import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ObservacaoEstudoComponent } from './observacao-estudo.component';
import { FormsModule } from '@angular/forms';
import { MatSelectModule, MatButtonModule, MatIconModule, MatInputModule, MatToolbarModule, MatProgressBarModule, MatSnackBarModule, MatTabsModule, MatCheckboxModule, MatDialogModule, MatListModule, MatCardModule } from '@angular/material';
import { ObservacaoEstudoButtonComponent } from './observacao-estudo-button.component';
import { ObservacaoEstudoDialog } from './observacao-estudo-dialog';
import { ObservacaoEstudoService } from './observacao-estudo.service';

@NgModule({
  imports: [
    CommonModule, FormsModule,
    MatSelectModule, MatButtonModule, MatIconModule, MatInputModule, MatProgressBarModule, MatSnackBarModule, MatDialogModule, MatCardModule, MatListModule, MatToolbarModule, MatTabsModule
  ],
  declarations: [ObservacaoEstudoComponent, ObservacaoEstudoButtonComponent, ObservacaoEstudoDialog],
  exports: [
    ObservacaoEstudoComponent, ObservacaoEstudoButtonComponent, ObservacaoEstudoDialog
  ],
  providers: [
    ObservacaoEstudoService, 
  ]

})
export class ObservacaoEstudoModule { }
